import { useContext, useEffect, useState, useRef } from "react";
import { message, Card, Button, Tag, Modal, Progress } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Context } from "../../context";
import { Delete, Fetch } from "../../fetch";
import "fp-web-uploads"
import { notification } from 'antd';
import { Uploader } from "@fastpix/resumable-uploads";
const { confirm } = Modal;

const isReadyStatus = (status) => status === "ready" || status === "media_ready";

const DirectUpload = ({
  content_id,
  content_type,
  content_title,
  card_title,
  status,
  custom_image,
  download_url,
  duration,
}) => {

  const defaultImage =
    "https://pub-e9e62c3abede4a2086580d06cb0e7b62.r2.dev/images/1483bf95-8f1a-443f-9050-1e2bd88e3a13.png";
  const { token, apiUrl } = useContext(Context);
  
  const [currentStatus, setCurrentStatus] = useState(status);
  const [displayStatus, setDisplayStatus] = useState(status);
  const [downloadLink, setDownloadLink] = useState(download_url);
  const [pullData, setPullData] = useState(false);
  const [intervalTime, setIntervalTime] = useState(1000);
  const [customImage, setCustomImage] = useState();
  const [signedUrl, setSignedUrl] = useState("");
  const [mediaIdTrailer, setMediaIdTrailer] = useState("");
  const [mediaIdContent, setMediaIdContent] = useState("");
  const [isUserRequestedReUpload, setIsUserRequestedReUpload] = useState(false);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  
  const fileInputRef = useRef(null);
  const fileUploadRef = useRef(null);

  useEffect(()=> {
    const checkImage= (url)=> {
      
      var request = new XMLHttpRequest();
      request.open("GET", url, true);
      request.send();
      request.onload = function() {

        if (request.status === 200 && custom_image)
        {
          setCustomImage(custom_image);
        } else {
          setCustomImage(defaultImage);
        }
      }
    }

    checkImage(custom_image)
  },[custom_image]);

  useEffect(() => {
    let intervalId;
    const startInterval = () => {
      intervalId = setInterval(() => {
        setPullData(true);
        setIntervalTime((prevIntervalTime) => prevIntervalTime * 2);
      }, intervalTime);
    };
    startInterval();
    return () => clearInterval(intervalId);
  }, [intervalTime]);

  useEffect(() => {
    if (!pullData) {
      return;
    }
    let collection, id, video_type;
    if (content_type.includes("trailer")) {
      collection = content_type.split("_")[0];
      video_type = content_type.split("_")[1];
      console.log(collection, video_type);
      id = content_id;
    } else {
      collection = content_type;
      video_type = "playbackUrl";
      id = content_id;
    }

    if (collection === "episode") {

      Fetch(`${apiUrl}/episodes?id=${id}`, token, (apiData) => {

          let result = apiData?.data;
          setMediaIdContent(result?.media_id_content)
          if (result?.mp4PlaybackUrl) {
            setDisplayStatus("READY");
            setCurrentStatus("ready");
            setDownloadLink(result.mp4PlaybackUrl);
          } else {
            setDisplayStatus("PROCESSING");
            setDownloadLink(null);
          }
        
      });
    } else if (collection === "movies") {
      Fetch(`${apiUrl}/movies/${id}`, token, (result) => {
        if (result) {

          setMediaIdContent(result?.media_id_content)
          setMediaIdTrailer(result?.media_id_trailer)
          if (video_type === "trailer") {
            if (!result.trailerStatus) {
              if (result.mp4Trailer) {
                setDisplayStatus("READY");
                setCurrentStatus("ready");
                setDownloadLink(result.mp4Trailer);
              } else {
                setDisplayStatus("PROCESSING");
                setDownloadLink(null);
              }
            // } else if (result.trailerStatus === "ready") {
            }else if (isReadyStatus(result.trailerStatus)) {
              setDisplayStatus("READY");
              setCurrentStatus("ready");
              setDownloadLink(result.mp4Trailer);
            } else {
              setDisplayStatus("PROCESSING");
              setDownloadLink(null);
            }
          } else if (video_type === "playbackUrl") {
            if (!result.playbackUrlStatus) {
              if (result.mp4PlaybackUrl) {
                setDisplayStatus("READY");
                setCurrentStatus("ready");
                setDownloadLink(result.mp4PlaybackUrl);
              } else {
                setDisplayStatus("PROCESSING");
                setDownloadLink(null);
              }
            // } else if (result.playbackUrlStatus === "ready") {
            } else if (isReadyStatus(result.playbackUrlStatus)) {
            
              setDisplayStatus("READY");
              setCurrentStatus("ready");
              setDownloadLink(result.mp4PlaybackUrl);
            } else {
              setDisplayStatus("PROCESSING");
              setDownloadLink(null);
            }
          } else {
            setDisplayStatus("PROCESSING");
            setDownloadLink(null);
          }
        }
      });
    } else if (collection === "season") {
      Fetch(`${apiUrl}/seasons/123456789/${id}`, token, (result) => {
        if (result.success === true) {
          
          let season = result.season;
          setMediaIdTrailer(season.media_id_trailer)

          if (!season.mp4Trailer) {
            setDisplayStatus("PROCESSING");
            setDownloadLink(null);
          } else {
            setDisplayStatus("READY");
            setCurrentStatus("ready");
            setDownloadLink(season.mp4Trailer);
          }
        }
      });
    } else {
      return;
    }
    setPullData(false);
  }, [apiUrl, token, content_id, content_type, pullData]);

  const uploadFPVideo = async () => {
    const accessibility = content_type === 'movies' || content_type === "episode" ? "private" : "public"

    const data = {
      "content_id": content_id,
      "accessibility": accessibility,
      "content_title": content_title,
      "content_type": content_type
    }

    const getPresignedUrl = await fetch(`${apiUrl}/fpvideo/getPresignedUrl`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(data)
    })
    
    const response = await getPresignedUrl.json();
    setSignedUrl(response?.data?.url);
  };

  const handleReupload = () => {
    setIsUserRequestedReUpload(true);
    
    setCurrentStatus(null);
    uploadFPVideo()
  };

  useEffect(() => {
    const uploadFPVideo = async () => {
      const accessibility = content_type === 'movies' || content_type === "episode" ? "private" : "public"

      const data = {
        "content_id": content_id,
        "accessibility": accessibility,
        "content_title": content_title,
        "content_type": content_type
      }

      const getPresignedUrl = await fetch(`${apiUrl}/fpvideo/getPresignedUrl`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(data)
      })

      const response = await getPresignedUrl.json();
      setSignedUrl(response?.data?.url);
    };
    uploadFPVideo()
  }, [apiUrl, token, content_id, content_title, content_type])

  const startProgrammaticUpload = (file) => {
    if (!signedUrl) {
      notification.error({
        message: 'Missing Upload URL',
        description: 'Please try again in a moment.',
        duration: 2,
      });
      return;
    }

    try {
      const uploader = Uploader.init({
        endpoint: signedUrl,
        file,
        chunkSize: 131072,
      });

      fileUploadRef.current = uploader;

      setIsUploading(true);
      setUploadProgress(0);
      notification.info({
        message: 'Upload Started',
        description: 'Your file upload has started',
        duration: 2,
      });

      uploader.on("progress", (event) => {
        const percent = Math.round(event.detail.progress || event.detail || 0);
        setUploadProgress(percent);
      });

      uploader.on("success", () => {
        setCurrentStatus("uploaded");
        setIsUploading(false);
        setIsUserRequestedReUpload(false);
        notification.success({
          message: 'Upload Successful',
          description: 'File uploaded successfully',
          duration: 2,
        });
      });

      uploader.on("error", (event) => {
        const messageText = event?.detail?.message || 'Failed to upload file';
        setIsUploading(false);
        notification.error({
          message: 'Upload Failed',
          description: messageText,
          duration: 3,
        });
      });
    } catch (e) {
      setIsUploading(false);
      notification.error({
        message: 'Upload Failed',
        description: e?.message || 'Unexpected error occurred',
        duration: 3,
      });
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      startProgrammaticUpload(file);
    }
  };

  const displayUploadComponent = () => {
    const isContentExists = duration !== "00:00:00" && duration !== undefined && duration !== null;

    if ((currentStatus === "uploaded" || isContentExists) && (!isUserRequestedReUpload) && (currentStatus !== null)) {
      return (
        <div className="upload-container">
          <div className="custom-image-container-left">
            <img
              src={customImage !== null ? customImage : "https://pub-e9e62c3abede4a2086580d06cb0e7b62.r2.dev/images/1483bf95-8f1a-443f-9050-1e2bd88e3a13.png"}
              alt="Video Thumbnail"
            />
          </div>
          <div className="actions-container-right">
            <Tag color="green" style={{ minHeight: "25px", textTransform: 'cuppercase' }}>
              {displayStatus}
            </Tag>
            <br />
            {downloadLink && currentStatus === "ready" ? (
              <Button type="primary" href={downloadLink} target="_blank">
                Download
              </Button>
            ) : null}
            <br />
            <Button type="primary" onClick={handleReupload}>
              Re-upload
            </Button>
            <br />
            {downloadLink && currentStatus === "ready" ? (
              <Button
                type="primary"
                danger
                onClick={() => {
                  confirm({
                    title: "Are you sure you want to delete the video?",
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    okType: "primary",
                    okButtonProps: { danger: true },
                    cancelText: "No",
                    onOk() {
                      handleDeleteVideo({
                        content_id: content_id,
                        content_type: content_type,
                      });
                    },
                  });
                }}
              >
                Delete
              </Button>
            ) : null}
          </div>
        </div>
      );
    } else if (currentStatus === "ready") {
      return (
        <div className="upload-container">
          <div className="custom-image-container-left">
            <img
              src={customImage ? customImage : "https://pub-e9e62c3abede4a2086580d06cb0e7b62.r2.dev/images/1483bf95-8f1a-443f-9050-1e2bd88e3a13.png"}
              alt="Video Thumbnail"
            />
          </div>
          <div className="actions-container-right">
            <Tag color="green" style={{ textTransform: 'uppercase' }}>{displayStatus}</Tag>
            <br />
            {downloadLink && (
              <Button type="primary" href={downloadLink} target="_blank">
                Download
              </Button>
            )}
            <br />
            <Button type="primary" onClick={handleReupload}>
              Re-upload
            </Button>
            <br />
            {downloadLink && (
              <Button
                type="primary"
                danger
                onClick={() => {
                  confirm({
                    title: "Are you sure you want to delete the video?",
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    okType: "primary",
                    okButtonProps: { danger: true },
                    cancelText: "No",
                    onOk() {
                      handleDeleteVideo({
                        content_id: content_id,
                        content_type: content_type,
                      });
                    },
                  });
                }}
              >
                Delete
              </Button>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="upload-container">
          <div className="custom-image-container-left">
            <img
              src={customImage ? customImage : "/images/RLTV_OG_image_2.png"}
              alt="Video Thumbnail"
            />
          </div>
          <div className="actions-container-right">
            <Button 
              type="primary" 
              onClick={handleButtonClick} 
              loading={isUploading}
              style={{ width: '100%', maxWidth: '200px' }}
            >
              {isUploading ? 'Uploading...' : 'Select File'}
            </Button>
            <input type="file" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }} />
            {uploadProgress > 0 && (
              <div style={{ marginTop: 12 }}>
                <Progress percent={uploadProgress} size="small" />
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const handleDeleteVideo = (payload) => {
    const mediaId = payload?.content_type?.includes("trailer") ? mediaIdTrailer : mediaIdContent 
  
    Delete(
      `${apiUrl}/fpvideo?content_id=${payload["content_id"]}&content_type=${payload["content_type"]}&media_id=${mediaId}`,
      token,
      (result) => {
        if (result.success === true) {
          message.success("Deleted Successfully");
          setCurrentStatus(null);
        } else {
          message.error(result.message);
        }
      }
    );
  };

  return (
    <div style={{ margin: "2%" }}>
      <Card
        bordered={true}
        title={card_title}
        hoverable={true}
        style={{ minHeight: "350px", maxHeight: "500px", height: "350px" }}
      >
        {displayUploadComponent()}
      </Card>
    </div>
  );
};

export default DirectUpload;
